import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

// An item can belong to more than one restaurant (e.g. a shared dish
// across locations) - checkbox list, not a single dropdown. ?all=true
// includes inactive restaurants too, so an existing item's restaurant
// still shows (and stays editable) even while that restaurant is
// temporarily hidden from the storefront directory.
const RestaurantSelect = ({ value = [], onChange }) => {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const selected = Array.isArray(value) ? value : [];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/restaurant?all=true`)
      .then((res) => setRestaurants(res.data.restaurants))
      .catch((err) => console.error("Error fetching restaurants:", err))
      .finally(() => setLoading(false));
  }, []);

  const toggle = (id) => {
    if (selected.includes(id)) {
      onChange(selected.filter((r) => r !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <div>
      <label className="block font-semibold mb-1 text-ink">Restaurants</label>
      {loading ? (
        <p className="text-sm text-sub">Loading restaurants…</p>
      ) : restaurants.length === 0 ? (
        <p className="text-sm text-red-600">
          No restaurants yet - add one under Restaurants in the sidebar first.
        </p>
      ) : (
        <div className="space-y-1.5 p-2 border border-line rounded">
          {restaurants.map((r) => (
            <label key={r._id} className="flex items-center gap-1.5 text-sm text-ink">
              <input
                type="checkbox"
                checked={selected.includes(r._id)}
                onChange={() => toggle(r._id)}
              />
              {r.name}
              {!r.active && <span className="text-muted">(hidden)</span>}
            </label>
          ))}
        </div>
      )}
      {selected.length === 0 && (
        <p className="text-xs text-red-600 mt-1">Pick at least one restaurant.</p>
      )}
    </div>
  );
};

export default RestaurantSelect;
